import axios from 'axios';
import { useQuery } from '@tanstack/react-query';

export function getObservers(
  accountId: number,
  takenAt: string,
  ageLevel: string
) {
  return axios.get(
    `/api/v2/accounts/${accountId}/observers?age_level=${ageLevel}&taken_at=${takenAt}`
  );
}

export function getAllObservers(accountId: number) {
  return axios.get(`/api/v2/accounts/${accountId}/observers/all`);
}

export function useGetAllObservers(accountId: number) {
  return useQuery({
    queryKey: ['accounts', accountId, 'observers', 'all'],
    queryFn: () => getAllObservers(accountId).then(response => response.data),
    enabled: Boolean(accountId),
    refetchOnWindowFocus: false,
    refetchOnReconnect: false
  });
}
